export async function copyToClipboard(text) {
  try {
    // Check if Clipboard API is available
    if (!navigator.clipboard) {
      throw new Error('Clipboard API not supported');
    }

    // Attempt to write text to clipboard
    await navigator.clipboard.writeText(text);

    // Return the original text on successful copy
    return text;
  } catch (err) {
    // Log the error
    console.error('Failed to copy text: ', err);

    // Fallback: try using document.execCommand (for older browsers)
    try {
      const textArea = document.createElement('textarea');
      textArea.value = text;

      // Make the textarea out of viewport
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);

      textArea.focus();
      textArea.select();

      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);

      return successful ? text : '';
    } catch (fallbackErr) {
      console.error('Fallback copy method failed: ', fallbackErr);
      return '';
    }
  }
}

export const ClipboardPlugin = {
  install(Vue) {
    Vue.prototype.$copyToClipboard = copyToClipboard;
  },
};
